import { render, staticRenderFns } from "./pieHomeEpide.vue?vue&type=template&id=3a809ce2&"
import script from "./pieHomeEpide.vue?vue&type=script&lang=js&"
export * from "./pieHomeEpide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports